import React, { useEffect, useState, useCallback } from 'react'
import ResourceForm from './ResourceForm'
import Loader from '../shared/Loader'
import ResourcesService from '../../services/api/ResourcesService'

let idCounter = 0
const idGenerator = () => `new-${new Date().getTime() + idCounter++}`


const ResourceNew = ({ ensembleId }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [formErrors, setFormErrors] = useState({})

  useEffect(() => {
    const fetchNewResource = async() => {
      try {
        setLoading(true)
        const response = await ResourcesService.getNewResource(ensembleId)
        response.values.forEach(value => {
          value.id = idGenerator()
        })
        setData(response)
        setError(null)
      } catch {
        setError('Erreur lors du chargement du formulaire')
      } finally {
        setLoading(false)
      }
    }

    fetchNewResource()
  }, [ensembleId])

  const handleSubmit = useCallback(async submitData => {
    setSubmitting(true)
    setFormErrors({})

    try {
      const result = await ResourcesService.createResource(ensembleId, submitData)
      if (result.success === true) {
        const noticeParam = result.notice ? `?notice=${encodeURIComponent(result.notice)}` : ''
        window.location.href = `/ensembles/${ensembleId}/resources${noticeParam}`
      }
      else {
        setFormErrors(result.formatted_errors || {})
        setSubmitting(false)
      }
    } catch (err) {
      const errorMessage = err.message || 'Une erreur est survenue lors de la création'
      setFormErrors({ base: [errorMessage] })
      setSubmitting(false)
    }
  }, [ensembleId])

  if (loading) {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <div className="row">
            <div className="col-md-6">
              <h2 className="d-inline">
                <i className="fas fa-cube" />
                {' Création d\'une nouvelle ressource'}
              </h2>
            </div>
            <div className="col-md-6">
              <a
                className="btn btn-primary float-md-right mt-2 mt-md-0"
                href={`/ensembles/${ensembleId}/resources`}
              >
                <i className="fas fa-reply" />
                {' Retour'}
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <Loader text="Chargement du formulaire en cours..." />
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <div className="row">
            <div className="col-md-6">
              <h2 className="d-inline">
                <i className="fas fa-cube" />
                {' Création d\'une nouvelle ressource'}
              </h2>
            </div>
            <div className="col-md-6">
              <a
                className="btn btn-primary float-md-right mt-2 mt-md-0"
                href={`/ensembles/${ensembleId}/resources`}
              >
                <i className="fas fa-reply" />
                {' Retour'}
              </a>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="alert alert-danger">
            {error}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="card-header bg-light">
        <div className="row">
          <div className="col-md-6">
            <h2 className="d-inline">
              <i className="fas fa-cube" />
              {' Création d\'une nouvelle ressource'}
            </h2>
          </div>
          <div className="col-md-6">
            <a
              className="btn btn-primary float-md-right mt-2 mt-md-0"
              href={`/ensembles/${ensembleId}/resources`}
            >
              <i className="fas fa-reply" />
              {' Retour'}
            </a>
          </div>
        </div>
      </div>
      <div className="card-body">
        {data ? (
          <ResourceForm
            data={data}
            submitting={submitting}
            errors={formErrors}
            mode="new"
            onSubmit={handleSubmit}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ResourceNew